module.exports = "<template> <div class=tyl-chip-set part=root> <slot></slot> </div> </template>";